import { render } from "./NotFound.vue?vue&type=template&id=317b213c"
const script = {}

import exportComponent from "/Users/jj_mac/Documents/find-a-mentor-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__